import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  Card,
  Typography,
  IconButton,
  Icon
} from '@material-ui/core';
import {deleteHelpSubCategoryApi} from 'api/help';


const SubTabsList = ({setSubCategory}) => {
  const dispatch = useDispatch();
  const { helpSubCategories } = useSelector((state) => state.help);

  return (
    <div>
      <Typography variant="h4" className="text-brand ml-4 mt-8">Sub-Categories List</Typography>
      {helpSubCategories.map((element) => (
        <Card
          className="p-4 m-4 flex justify-between items-center"
          key={element._id}
        >
          <Typography variant="h6" className="text-brand">{element.title}</Typography>
          <div>
            <IconButton
              className="mr-2"
              title="Edit"
              onClick={() => setSubCategory(element)}
            >
              <Icon className="text-gray">edit</Icon>
            </IconButton>
            <IconButton
              className="mr-2"
              title="Delete"
              onClick={() => deleteHelpSubCategoryApi({dispatch, subCategoryId: element._id})}
            >
              <Icon className="text-gray">delete</Icon>
            </IconButton>
          </div>

        </Card>
      ))}
    </div>
  );
};

export default SubTabsList;
